import { useContext, useEffect } from "react";
import PayPalButton from "./PayPalButton";
import BraintreeStateContext from "./BraintreeStateContext";
import MainStateContext from "../state/mainStateContext";
import { useRequestOrder } from "../orderRequest/useOrderRequest";
import { wvusLogger } from "../helpers";

const PayPalButtonWrapper = (props) => {
  const { setOrderPayload, hasProduct } = props;
  const braintreeContext = useContext(BraintreeStateContext);
  const mainContext = useContext(MainStateContext);
  const { dispatch } = braintreeContext;
  const braintreeState = braintreeContext?.state || {};
  const { paypalData } = braintreeState;

  // Access orderRequestCtx from custom hook
  const { orderRequestCtx } = useRequestOrder();

  // Prevent useEffect logic if orderRequestCtx.state.status is "requesting"
  const hasNoOrderRequesting = () => {
    return orderRequestCtx.state.status !== "requesting";
  };

  useEffect(() => {
    if (!hasNoOrderRequesting()) {
      console.warn("Order is currently requesting. Skipping PayPal data update.");
      return; // Prevent triggering if an order is already in "requesting" status
    }

    if (paypalData && paypalData?.tokenizedPaymentData?.nonce) {
      const { tokenizedPaymentData, braintreePaymentInfo } = paypalData;
      const { details, nonce } = tokenizedPaymentData;

      const billingAddress = {
        address1: details?.billingAddress?.line1,
        address2: details?.billingAddress?.line2,
        city: details?.billingAddress?.city,
        state: details?.billingAddress?.state,
        postcode: details?.billingAddress?.postalCode,
        firstName: details?.firstName,
        lastName: details?.lastName,
        email: details?.email,
        phone: details?.phone // TODO: normalize phone number
      };

      const paymentInfo = {
        paymentMethod: "paypal",
        nonce: nonce,
        braintreePaymentInfo: braintreePaymentInfo
      };

      setOrderPayload({
        billingAddress,
        paymentInfo
      });
    }
  }, [paypalData]);

  const onPaymentComplete = (result) => {
    const { tokenizedPaymentData = {}, error } = result;

    if (!error && tokenizedPaymentData?.nonce) {
      dispatch({ type: "SET_PAYPAL_DATA", payload: result });
    } else if (error) {
      mainContext?.dispatch({
        type: "SET_SUBMIT_MESSAGE_PHRASE_KEY",
        payload: "errors.general_error_volunteer"
      });
      wvusLogger.log(error, wvusLogger.getLogLevelNames().ERROR);
    } else {
      const err = new Error("Missing paypal nonce");
      mainContext?.dispatch({
        type: "SET_SUBMIT_MESSAGE_PHRASE_KEY",
        payload: "errors.alt_payment_error"
      });
      wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    }
  };

  return <PayPalButton onPaymentComplete={onPaymentComplete} disabled={!hasProduct} />;
};

export default PayPalButtonWrapper;
